import { render, staticRenderFns } from "./lgViolateOrders.vue?vue&type=template&id=b6d4b1ac&"
import script from "./lgViolateOrders.vue?vue&type=script&lang=js&"
export * from "./lgViolateOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports